<template>
    <b-form-group
        label-for="metrics-select"
        :label="$t('keyResult.metrics.metric')"
    >
        <Select
            id="metrics-select"
            :state="state"
            :selected="getDefaultOption"
            :options="options"
            @changeValue="emitUpdateEvent"
        />
    </b-form-group>
</template>
<script>
import { Select } from '@/views/components/selects'
export default {
    components: {
        Select,
    },
    props: {
        value: {
            type: String | null,
            default: null,
        },
        state: {
            type: Boolean | null,
            default: null,
        },
    },
    computed: {
        options() {
            return [
                {
                    value: 'numeric',
                    prepend: null,
                    append: null,
                    decimals: '0.01',
                    label: this.$t('keyResult.metrics.types.numeric'),
                },
                {
                    value: 'monetary',
                    prepend: '$ ',
                    append: null,
                    decimals: '0.01',
                    label: this.$t('keyResult.metrics.types.monetary'),
                },
                {
                    value: 'percentage',
                    prepend: null,
                    append: '%',
                    decimals: '0.01',
                    label: this.$t('keyResult.metrics.types.percentage'),
                },
                {
                    value: 'binary',
                    prepend: null,
                    append: null,
                    decimals: '0',
                    label: this.$t('keyResult.metrics.types.binary'),
                },
            ]
        },
        getDefaultOption() {
            return this.options.find((o) => o.value == this.value)
        },
    },
    created() {
        this.setDefaultValue()
    },
    methods: {
        setDefaultValue() {
            if (this.value != null) {
                return
            }

            this.getDefaultOption

            this.emitUpdateEvent(this.getDefaultOption)
            this.emitDefaultValueEvent(this.getDefaultOption)
        },
        emitUpdateEvent(value) {
            this.$emit('updateValue', value)
            this.$emit('input', value)
        },
        emitDefaultValueEvent(value) {
            this.$emit('default-value', value)
        },
    },
}
</script>
